import { render, staticRenderFns } from "./ClienteVenta.vue?vue&type=template&id=6f18349d&scoped=true"
import script from "./ClienteVenta.vue?vue&type=script&lang=js"
export * from "./ClienteVenta.vue?vue&type=script&lang=js"
import style0 from "./ClienteVenta.vue?vue&type=style&index=0&id=6f18349d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f18349d",
  null
  
)

export default component.exports